import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

import { Title } from '../../Element';

const SessionRegistrationHeader = ({ title, subtitle, count = null }) => {
  return (
    <div>
      <Title lvl={2} className={'checkout-summary-layout__title'}>
        <Trans count={count}>{title}</Trans>
      </Title>
      <p className="checkout-summary-layout__subtitle">
        <Trans count={count}>{subtitle}</Trans>
      </p>
    </div>
  );
};

SessionRegistrationHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default SessionRegistrationHeader;
